import CryptoJS from 'crypto-js'

const md5 = (str) => {
    let r = CryptoJS.MD5(str);
    return r.toString().substring(0, 8).toLowerCase();
}

export default md5;